import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import './styles/global.css'

const installAntiDebug = () => {
  let blocked = false
  const block = () => {
    if (blocked) return
    blocked = true
    try {
      document.body.innerHTML = '<div style="height:100vh;display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;color:#111;background:#fff;"><div style="text-align:center;max-width:520px;padding:24px;"><div style="font-size:18px;font-weight:600;margin-bottom:8px;">当前环境不支持调试</div><div style="font-size:14px;color:#666;line-height:1.6;">请关闭调试工具后重试</div></div></div>'
    } catch (e) { void e }
    try {
      window.stop()
    } catch (e) { void e }
    try {
      Object.defineProperty(window, 'fetch', { value: undefined, writable: false, configurable: false })
    } catch (e) { void e }
  }

  const threshold = 160
  const check = () => {
    if (blocked) return
    const widthGap = window.outerWidth - window.innerWidth
    const heightGap = window.outerHeight - window.innerHeight
    if (widthGap > threshold || heightGap > threshold) {
      block()
      return
    }
    const start = performance.now()
    Function('debugger')()
    const delta = performance.now() - start
    if (delta > 200) {
      block()
    }
  }

  document.addEventListener('contextmenu', (e) => {
    e.preventDefault()
  }, true)

  document.addEventListener('keydown', (e) => {
    const key = (e.key || '').toUpperCase()
    const isF12 = key === 'F12'
    const isDevtoolsCombo = e.ctrlKey && e.shiftKey && (key === 'I' || key === 'J' || key === 'C')
    const isViewSource = e.ctrlKey && key === 'U'
    if (isF12 || isDevtoolsCombo || isViewSource) {
      e.preventDefault()
      e.stopPropagation()
      block()
    }
  }, true)

  window.addEventListener('resize', check)
  window.addEventListener('focus', check)
  setInterval(check, 1500)
  setTimeout(check, 0)
}

if (process.env.NODE_ENV === 'production') {
  installAntiDebug()
}

createApp(App).use(router).mount('#app')
